import n from "./ghl-ui.es818.js";
function t(r, f) {
  var e = f ? n(r.buffer) : r.buffer;
  return new r.constructor(e, r.byteOffset, r.byteLength);
}
export {
  t as default
};
